import React from 'react';

const TableWidget = ({ title, data, columns = ['Item', 'Count'] }) => {
  // Convert data object to array if needed
  const getTableData = () => {
    if (!data) return [];

    if (Array.isArray(data)) {
      return data;
    }

    if (typeof data === 'object') {
      return Object.entries(data).map(([key, value]) => ({
        label: key,
        value: value,
      }));
    }

    return [];
  };

  const tableData = getTableData();

  const getRowClassName = (row) => {
    // Highlight failed/error rows based on Status property or first column value
    if (row.status && row.status.toLowerCase() === 'error') {
      return 'error-row';
    }

    const label = row.label || row[columns[0]] || row.fileType || row.status || '';
    if (typeof label === 'string' && (label.toLowerCase().includes('failed') || label.toLowerCase().includes('error'))) {
      return 'error-row';
    }

    return '';
  };

  const getCellValue = (row, columnIndex) => {
    if (row.label && row.value !== undefined && columnIndex === 0) {
      return row.label;
    }
    if (row.label && row.value !== undefined && columnIndex === 1) {
      return row.value;
    }

    const columnName = columns[columnIndex];

    // Try exact match first
    if (row[columnName] !== undefined) {
      return row[columnName];
    }

    // Try camelCase version (e.g., "File Type" -> "fileType")
    const camelCaseKey = columnName.replace(/\s+(.)/g, (match, char) => char.toUpperCase())
                                    .replace(/^\w/, (char) => char.toLowerCase());
    if (row[camelCaseKey] !== undefined) {
      return row[camelCaseKey];
    }

    // Try lowercase version (e.g., "Count" -> "count")
    const lowerKey = columnName.toLowerCase();
    if (row[lowerKey] !== undefined) {
      return row[lowerKey];
    }

    return '--';
  };

  return (
    <div className="widget table-widget">
      <div className="widget-header">
        <span className="widget-title">{title}</span>
      </div>
      <div className="widget-body" style={{ justifyContent: 'flex-start', alignItems: 'stretch' }}>
        <table className="widget-table">
          <thead>
            <tr>
              {columns.map((col, index) => (
                <th key={index}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData.length > 0 ? (
              tableData.map((row, rowIndex) => (
                <tr key={rowIndex} className={getRowClassName(row)}>
                  {columns.map((col, colIndex) => (
                    <td key={colIndex}>{getCellValue(row, colIndex)}</td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length} style={{ textAlign: 'center', color: '#b0b0b0' }}>
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableWidget;
